import { recoveryPrefix } from '../../../../packages/shared/browser-recovery/storage';
import { useMemo, useSyncExternalStore } from 'react';
import { createCountCommands, countAccountKey, countRequest, type CountCommands } from '../../../../packages/shared/stock-count/client';
import { useAuth } from '../../App';
const API_URL = import.meta.env.VITE_API_URL || 'https://api.whenlyapp.com';
const commands = new Map<string, CountCommands>();
window.addEventListener('storage', () => commands.forEach(command => command.refreshSaved()));
window.addEventListener('beforeunload', event => {
  if ([...commands.values()].some(value => value.snapshot().pending)) { event.preventDefault(); event.returnValue = ''; }
});
export function useCountClient() {
  const { user, currentShop } = useAuth();
  const account = useMemo(() => ({ userId: String(user?.id || ''), domain: currentShop?.domain || '', organizationId: currentShop?.organizationId }), [user?.id, currentShop?.domain, currentShop?.organizationId]);
  const key = countAccountKey(account);
  if (!commands.has(key)) commands.set(key, createCountCommands(API_URL, account));
  const command = commands.get(key)!;
  const state = useSyncExternalStore(command.subscribe, command.snapshot);
  const read = useMemo(() => <T,>(path: string, signal?: AbortSignal) => countRequest<T>(API_URL, account, path, { signal }), [account]);
  return { key, draftKey: recoveryPrefix('draft', API_URL, account), read, ...state, reviewLine: command.reviewLine, submit: command.submit, retry: command.retry };
}
